/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 2e2df032d94123e0bb11ec420c947508 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EstimateActions = "CHOOSE_OPTION" | "PROVIDE_USER" | "UPDATE_DATA" | "%future added value";
export type EstimateState = "CALCULATING_OPTIONS" | "COMPLETED" | "CREATED" | "GDPR_CLEANED" | "LEAD_DETAILS_NEEDED" | "NO_OPTIONS_AVAILABLE" | "OPTION_CHOICE_NEEDED" | "REJECTED" | "REJECTED_WITH_LEAD" | "SUPPORT_NEEDED" | "USER_NEEDED" | "VEHICLE_DETAILS_NEEDED" | "%future added value";
export type PrivateHirePriceEstimate2Input = {
    id?: string | null;
    action: EstimateActions;
    lead?: LeadInput | null;
    attribution?: AttributionInput | null;
    chosenOptionId?: string | null;
    data?: PrivateHirePriceEstimateDataInput | null;
};
export type LeadInput = {
    phoneNumber?: string | null;
    email?: string | null;
    givenNames?: string | null;
    lastName?: string | null;
    dateOfBirth?: string | null;
};
export type AttributionInput = {
    utmParams?: UTMParamsInput | null;
    testCohorts?: Array<TestingCohortInput> | null;
    featureName?: string | null;
    locationName?: string | null;
};
export type UTMParamsInput = {
    source: string;
    medium?: string | null;
    campaign?: string | null;
    term?: string | null;
    content?: string | null;
    adgroup?: string | null;
};
export type TestingCohortInput = {
    name: string;
    cohort: string;
};
export type PrivateHirePriceEstimateDataInput = {
    person?: PrivateHirePriceEstimatePersonInput | null;
    vehicle?: PrivateHirePriceEstimateVehicleInput | null;
};
export type PrivateHirePriceEstimatePersonInput = {
    dateOfBirth: string;
    postcode: string;
};
export type PrivateHirePriceEstimateVehicleInput = {
    noClaimsDuration: number;
};
export type usePrivateHireEstimateResultMutationVariables = {
    input: PrivateHirePriceEstimate2Input;
};
export type usePrivateHireEstimateResultMutationResponse = {
    readonly result: {
        readonly estimateResult: {
            readonly state: EstimateState;
            readonly lead?: {
                readonly email: string | null;
                readonly givenNames: string | null;
                readonly lastName: string | null;
                readonly phoneNumber: string | null;
                readonly dateOfBirth: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"PrivateHireQuickEstimatesGbContainer_estimateResult">;
        };
    } | null;
};
export type usePrivateHireEstimateResultMutation = {
    readonly response: usePrivateHireEstimateResultMutationResponse;
    readonly variables: usePrivateHireEstimateResultMutationVariables;
};



/*
mutation usePrivateHireEstimateResultMutation(
  $input: PrivateHirePriceEstimate2Input!
) {
  result: getPrivateHirePriceEstimate2(input: $input) {
    estimateResult {
      state
      ... on BaseEstimateResult {
        lead {
          email
          givenNames
          lastName
          phoneNumber
          dateOfBirth
        }
      }
      ...PrivateHireQuickEstimatesGbContainer_estimateResult
      id
    }
  }
}

fragment PrivateHireOptionTile_option on EstimateOption {
  rate {
    valueDecimal
    currency {
      isoCode
      symbol
    }
  }
  product {
    __typename
    code
    coverType
    frequency
    description
    id
  }
}

fragment PrivateHireQuickEstimatesGbContainer_estimateResult on PrivateHireEstimateResult {
  id
  state
  ...QuickEstimatesPersonalDetails_estimateResult
  ...QuickEstimatesAuthentication_estimateResult
  ...QuickEstimatesRejection_estimateResult
  ...QuickEstimatesSupportNeeded_estimateResult
  ...PrivateHireQuickEstimatesOptions_estimateResult
}

fragment PrivateHireQuickEstimatesOptions_estimateResult on PrivateHireEstimateResult {
  id
  state
  assumptions
  lead {
    givenNames
  }
  options {
    id
    ...PrivateHireOptionTile_option
    product {
      __typename
      code
      coverType
      frequency
      id
    }
  }
}

fragment QuickEstimatesAuthentication_estimateResult on BaseEstimateResult {
  lead {
    isEmailAvailable
  }
  ...QuickEstimatesLoginForm_estimateResult
  ...QuickEstimatesRegisterForm_estimateResult
}

fragment QuickEstimatesLoginForm_estimateResult on BaseEstimateResult {
  lead {
    email
    isEmailAvailable
  }
}

fragment QuickEstimatesPersonalDetails_estimateResult on BaseEstimateResult {
  id
}

fragment QuickEstimatesRegisterForm_estimateResult on BaseEstimateResult {
  lead {
    givenNames
    lastName
    phoneNumber
    email
    isEmailAvailable
    dateOfBirth
  }
}

fragment QuickEstimatesRejection_estimateResult on BaseEstimateResult {
  id
  state
  rejection {
    messageHtml
  }
}

fragment QuickEstimatesSupportNeeded_estimateResult on BaseEstimateResult {
  id
  state
  supportNeeded {
    messageHtml
    reason
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PrivateHirePriceEstimate2Input!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "givenNames",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phoneNumber",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dateOfBirth",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "messageHtml",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "usePrivateHireEstimateResultMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "result",
        "name": "getPrivateHirePriceEstimate2",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "GetPrivateHirePriceEstimate2Payload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimateResult",
            "storageKey": null,
            "args": null,
            "concreteType": "PrivateHireEstimateResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lead",
                "storageKey": null,
                "args": null,
                "concreteType": "Lead",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "PrivateHireQuickEstimatesGbContainer_estimateResult",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "usePrivateHireEstimateResultMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "result",
        "name": "getPrivateHirePriceEstimate2",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "GetPrivateHirePriceEstimate2Payload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimateResult",
            "storageKey": null,
            "args": null,
            "concreteType": "PrivateHireEstimateResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lead",
                "storageKey": null,
                "args": null,
                "concreteType": "Lead",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isEmailAvailable",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "rejection",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateResultRejection",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "supportNeeded",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateResultSupportNeeded",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "reason",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "assumptions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "options",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateOption",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "rate",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Price",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "valueDecimal",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currency",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Currency",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isoCode",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "symbol",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "coverType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "frequency",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "usePrivateHireEstimateResultMutation",
    "id": null,
    "text": "mutation usePrivateHireEstimateResultMutation(\n  $input: PrivateHirePriceEstimate2Input!\n) {\n  result: getPrivateHirePriceEstimate2(input: $input) {\n    estimateResult {\n      state\n      ... on BaseEstimateResult {\n        lead {\n          email\n          givenNames\n          lastName\n          phoneNumber\n          dateOfBirth\n        }\n      }\n      ...PrivateHireQuickEstimatesGbContainer_estimateResult\n      id\n    }\n  }\n}\n\nfragment PrivateHireOptionTile_option on EstimateOption {\n  rate {\n    valueDecimal\n    currency {\n      isoCode\n      symbol\n    }\n  }\n  product {\n    __typename\n    code\n    coverType\n    frequency\n    description\n    id\n  }\n}\n\nfragment PrivateHireQuickEstimatesGbContainer_estimateResult on PrivateHireEstimateResult {\n  id\n  state\n  ...QuickEstimatesPersonalDetails_estimateResult\n  ...QuickEstimatesAuthentication_estimateResult\n  ...QuickEstimatesRejection_estimateResult\n  ...QuickEstimatesSupportNeeded_estimateResult\n  ...PrivateHireQuickEstimatesOptions_estimateResult\n}\n\nfragment PrivateHireQuickEstimatesOptions_estimateResult on PrivateHireEstimateResult {\n  id\n  state\n  assumptions\n  lead {\n    givenNames\n  }\n  options {\n    id\n    ...PrivateHireOptionTile_option\n    product {\n      __typename\n      code\n      coverType\n      frequency\n      id\n    }\n  }\n}\n\nfragment QuickEstimatesAuthentication_estimateResult on BaseEstimateResult {\n  lead {\n    isEmailAvailable\n  }\n  ...QuickEstimatesLoginForm_estimateResult\n  ...QuickEstimatesRegisterForm_estimateResult\n}\n\nfragment QuickEstimatesLoginForm_estimateResult on BaseEstimateResult {\n  lead {\n    email\n    isEmailAvailable\n  }\n}\n\nfragment QuickEstimatesPersonalDetails_estimateResult on BaseEstimateResult {\n  id\n}\n\nfragment QuickEstimatesRegisterForm_estimateResult on BaseEstimateResult {\n  lead {\n    givenNames\n    lastName\n    phoneNumber\n    email\n    isEmailAvailable\n    dateOfBirth\n  }\n}\n\nfragment QuickEstimatesRejection_estimateResult on BaseEstimateResult {\n  id\n  state\n  rejection {\n    messageHtml\n  }\n}\n\nfragment QuickEstimatesSupportNeeded_estimateResult on BaseEstimateResult {\n  id\n  state\n  supportNeeded {\n    messageHtml\n    reason\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '7b62f196035803e39d8431d5db3d406a';
export default node;
